export default __webpack_public_path__ + "static/media/fb_icon.44650968.png";